import type {
  CreateFeedbackApiArg,
  FeedbackImageAttachmentRef,
  GmResponseCommonFeedbackImageAttachmentRef,
  UploadFeedbackImageApiArg,
} from '~/api/generated-api';

import { collectFeedbackImageAttachments } from './collectFeedbackImageAttachments';
import { buildFeedbackPayload } from './feedbackPayload.utils';

type UploadFeedbackImageUnwrap = (
  arg: UploadFeedbackImageApiArg
) => Promise<GmResponseCommonFeedbackImageAttachmentRef>;

type CreateFeedbackInvoke = (arg: CreateFeedbackApiArg) => {
  unwrap: () => Promise<unknown>;
};

/**
 * Uploads screenshot files (when present), then creates feedback with returned blob refs.
 */
export async function submitModalFeedbackWithUploads(params: {
  message: string;
  starRating: number | undefined;
  userId: string | null | undefined;
  organizationsId: string;
  fleetsId?: string;
  attachmentFiles: File[];
  uploadFeedbackImage: UploadFeedbackImageUnwrap;
  createFeedback: CreateFeedbackInvoke;
}): Promise<void> {
  let imageAttachments: FeedbackImageAttachmentRef[] | undefined;

  if (params.attachmentFiles.length > 0) {
    imageAttachments = await collectFeedbackImageAttachments({
      files: params.attachmentFiles,
      uploadFeedbackImage: params.uploadFeedbackImage,
      'cs-organization': params.organizationsId,
      'cs-fleet': params.fleetsId,
    });
  }

  const payload = buildFeedbackPayload({
    message: params.message,
    starRating: params.starRating,
    attachInfo: true,
    userId: params.userId,
    imageAttachments,
  });

  await params
    .createFeedback({
      'cs-organization': params.organizationsId,
      'cs-fleet': params.fleetsId,
      feedbackCreateRequest: payload,
    })
    .unwrap();
}
